<template>
  <div>
    <b-modal hide-footer id="edit-teacher" size="xl" body-class="py-0" centered title="Editar Docente"
      header-bg-variant="primary" header-text-variant="light" button-size="sm">
      <div class="p-0">
        <b-row>
          <b-col class="pt-3 pl-4" :style="{ backgroundColor: 'var(--platinum-light)' }">
            <form ref=" form" @submit.prevent="OnSubmit" @reset="onReset" v-if="show">
              <b-row class="pb-1">
                <!--   Nombre y Apellido   -->
                <b-col>
                  <b-form-group id="inputLastName" label="Apellido" label-for="lastName-input">
                    <b-form-input required id="lastName-input" v-model="form.lastName" type="text"
                      :disabled="disableFormInputs" trim>
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group id="inputName" label="Nombre" label-for="name-input">
                    <b-form-input required id="name-input" v-model="form.name" type="text" :disabled="disableFormInputs"
                      trim>
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group id="hiringDate" label="Contratación" label-for="hiringDate-input">
                    <b-form-datepicker id="hiringDate-input" :disabled="disableFormInputs" v-model="form.hiring_date"
                      locale="es"></b-form-datepicker>
                  </b-form-group>
                </b-col>
              </b-row>
              <!--   Email y Rol   -->
              <b-row class="pb-2">
                <b-col>
                  <b-form-group id="emailInput" label="Email" label-for="email-input">
                    <b-form-input required id="email-input" v-model="form.email" type="email"
                      :disabled="disableFormInputs" trim></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group id="roleInput" label="Rol:" label-for="teacher-roles-input">
                    <b-form-select id="teacher-roles-input" v-model="form.role" :options="teacherRoles"
                      :disabled="disableFormInputs" required></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-button @click="inactivateTeacherButton()" class="mt-4" :variant="inactiveTextButton.color">
                    {{ inactiveTextButton.text }}
                  </b-button>

                </b-col>
              </b-row>
              <!--   Color   -->
              <b-row class="pb-2">
                <b-col cols="9">
                  <template>
                    <div class="form__field">
                      <div class="form__label">
                        <strong>Color:</strong>
                      </div>
                      <div class="form__input">
                        <v-swatches :disabled="disableFormInputs" background-color="var(--platinum-light)"
                          v-model="form.color" :swatches="swatches" row-length="4" inline></v-swatches>
                      </div>
                    </div>
                  </template>
                </b-col>
                <b-col>
                  <p><strong>Color elegido: </strong></p>
                  <b-avatar v-if="!inactivateTeacher && form.color != ''" rounded="lg" :text="form.color"
                    :style="{ backgroundColor: form.color }" style="width: 150px; height: 80px"></b-avatar>
                  <b-avatar v-else-if="inactivateTeacher" rounded="lg" text="BLANCO"
                    style="background-color:#fafafa; color:#fafafa; border: 1px solid black; width: 150px; height: 80px"></b-avatar>
                  <b-avatar v-else rounded="lg" icon="question-lg"
                    style="background-color:#979595; width: 150px; height: 80px"></b-avatar>
                </b-col>
              </b-row>
              <!--   Firma   -->
              <b-form-group id="signatureInput" label="Agregar firma: " label-for="signature-input">
              </b-form-group>
              <b-row class="pb-4">
                <b-col>
                  <div>
                    <b-form-file :disabled="disableFormInputs" accept="image/jpeg, image/png, image/gif"
                      v-model="signatureFileTemp" placeholder="Elegir o arrastrar un archivo... "
                      drop-placeholder="Drop file"></b-form-file>
                    <div class="py-3 float-right">
                      <span v-if="displayWarning" class="mr-3 text-danger"> Debe subir un archivo </span>
                      <b-button :disabled="disableFormInputs" variant="success" class="mr-2"
                        @click="uploadSignatureTemp()">
                        <b-icon icon="upload" aria-hidden="true" class="mr-2"></b-icon> Subir</b-button>
                      <b-button :disabled="disableFormInputs" variant="danger" class="mr-2"
                        @click="removeTempSignature()"><b-icon icon="x-lg" aria-hidden="true"
                          class="mr-2"></b-icon>Eliminar</b-button>
                      <b-button :disabled="disableFormInputs" variant="info" @click="recoverSignature()"> <b-icon
                          icon="skip-backward-fill" aria-hidden="true" class="mr-2"></b-icon> Reestablecer</b-button>
                    </div>
                  </div>
                </b-col>
                <b-col>
                  <img v-if="signatureLoaded === true" :src="form.signature" height="100px" width="400px">
                  <img v-else src='../../assets/images/no_signature.png' height="100px" width="400px">
                </b-col>
              </b-row>
              <b-row>
                <b-alert v-model="showWarningInactive" variant="warning">
                  {{ warningMessage }}
                </b-alert>
              </b-row>
              <b-row>
                <b-col>
                  <b-progress v-if="bar.status === true" :value="bar.value" :variant="bar.color" :max=100 show-progress
                    animated></b-progress>
                </b-col>
              </b-row>
              <!-- Form Buttons -->
              <div>
                <b-row class="py-3 float-right">
                  <b-col>
                    <b-button @click="$bvModal.show('edit-teacher-confirm')" variant="primary">Guardar</b-button>
                  </b-col>
                  <b-col>
                    <b-button type="reset" variant="outline-secondary">Reestablecer</b-button>
                  </b-col>
                  <b-col>
                    <b-button @click="$bvModal.hide('edit-teacher')" variant="outline-danger">Cerrar</b-button>
                  </b-col>
                </b-row>
              </div>
              <b-modal hide-footer header-bg-variant="info" header-text-variant="light" id="edit-teacher-confirm"
                size="m" centered title="Confirmación">
                <h6> Estás seguro/a que desea guardar estos cambios? </h6>
                <b-row align-h="end" class="mt-4">
                  <b-col cols="4">
                    <b-button type="submit" @click="OnSubmit" variant="success">SI</b-button>
                  </b-col>
                  <b-col cols="4">
                    <b-button @click="$bvModal.hide('edit-teacher-confirm')" variant="danger">NO</b-button>
                  </b-col>
                </b-row>
                <template #modal-footer="{ }">
                </template>
              </b-modal>
            </form>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <b-modal hide-footer hide-header-close no-close-on-esc no-close-on-backdrop header-bg-variant="success"
      header-text-variant="light" id="edit-teacher-success" size="m" centered title="Edición de Docente">
      <h6> Editamos los datos de {{ form.name }}! </h6>
      <p class="pb-2"> Cambios guardados con éxito! </p>
      <b-button @click="hideSuccessModal()" variant="success">Listo!</b-button>

      <template #modal-footer="{ }">
      </template>
    </b-modal>
  </div>
</template>

<script>
// import { UsersService } from '@/services/users.service'
import { TeacherService } from '@/services/teacher.service'
import VSwatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.css'

export default {
  name: 'edit-teacher-modal',
  props: {
    teacherToEdit: Object
  },
  defaultSignatureImage: '../../assets/images/no_signature.png',
  components: { VSwatches }, // window['vue-swatches'] - from CDN
  data () {
    return {
      signatureFileTemp: null,
      signatureLoaded: false,
      swatches: [
        '', '#F64272', '#F493A7', '#B80087', '#F8524F',
        '#8b5aff', '#695E26', '#372772', '#D7331D',
        '#ffa51a', '#754306', '#55504E', '#202B31',
        '#5D4E46', '#8C7569', '#B09F96', '#5C5C5C',
        '#EB0E0A', '#257E3B', '#396A3A', '#AF4631',
        '#28777B', '#28657B', '#2B50AA', '#9CC4B2', '#06C6B9'
      ],
      teacherRoles: [
        { value: 'manager', text: 'Manager' },
        { value: 'coordinator', text: 'Coordinación' },
        { value: 'teacher', text: 'Docente' }
      ],
      form: {
        email: '',
        name: '',
        lastName: '',
        role: 'teacher',
        signature: null,
        color: '',
        active: '',
        hiring_date: ''
      },
      bar: {
        status: false,
        value: 20,
        color: 'primary'
      },
      displayWarning: false,
      show: true,
      showWarningInactive: false,
      disableFormInputs: false,
      inactivateTeacher: false,
      inactiveTextButton: {
        text: 'Pasar Docente a Inactivo/a',
        color: 'danger'
      },
      warningMessage: ''
    }
  },
  watch: {
    teacherToEdit: {
      handler () {
        this.updateForm()
      },
      immediate: true, // Trigger the handler immediately on component creation
      deep: true
    }
  },
  mounted () {
    this.updateForm()
  },
  computed: {},

  methods: {

    updateForm () {
      if (this.teacherToEdit.x_signature) {
        this.signatureLoaded = true
      }
      this.inactivateTeacher = !this.teacherToEdit.x_active
      this.showWarningInactive = this.inactivateTeacher
      this.disableFormInputs = this.inactivateTeacher

      this.inactiveTextButton.text = this.teacherToEdit.x_active ? 'Pasar Docente a Inactivo/a' : 'Pasar Docente a Activo/a'
      this.inactiveTextButton.color = this.teacherToEdit.x_active ? 'danger' : 'success'

      if (this.teacherToEdit && typeof this.teacherToEdit === 'object') {
        this.form = {
          email: this.teacherToEdit.x_email || '',
          name: this.teacherToEdit.x_name !== undefined ? this.teacherToEdit.x_name.split(' ').slice(0, -1).join(' ') : '',
          lastName: this.teacherToEdit.x_name !== undefined ? this.teacherToEdit.x_name.split(' ').slice(-1).join(' ') : '',
          role: this.teacherToEdit.x_job_title || '',
          signature: this.teacherToEdit.x_signature || '',
          color: this.teacherToEdit.x_color || '',
          active: this.teacherToEdit.x_active || false,
          hiring_date: this.teacherToEdit.x_hiring_date || ''
        }
      }
    },
    async OnSubmit (event) {
      event.preventDefault()
      this.$bvModal.hide('edit-teacher-confirm')
      this.bar.status = false
      this.bar.value = 40
      this.disableFormInputs = true
      // teacher edit
      const teacherName = this.form.name + ' ' + this.form.lastName
      const teacherInfo = {
        display_name: teacherName,
        x_name: teacherName,
        x_color: this.inactivateTeacher ? '#fafafa' : this.form.color,
        x_signature: this.form.signature,
        x_email: this.form.email,
        x_job_title: this.form.role,
        x_active: !this.inactivateTeacher,
        x_hiring_date: this.form.hiring_date
      }
      // console.log('teacher full info---------- ', teacherInfo)
      try {
        const editTeacher = await TeacherService.update(this.teacherToEdit.id, teacherInfo)
        if (editTeacher) {
          this.bar.value = 100
          this.bar.variant = 'success'
          this.$bvModal.show('edit-teacher-success')
        }
      } catch (error) {
        console.log('Error en la edición de Docente: ', error)
      }
    },
    hideSuccessModal () {
      // close modals
      this.bar.status = false
      this.bar.value = 20
      this.$emit('updateTeachers')
      this.$bvModal.hide('edit-teacher')
      this.$bvModal.hide('edit-teacher-success')
    },
    onReset (event) {
      event.preventDefault()
      // Reset our form values
      this.updateForm()
      // Trick to reset/clear native browser form validation state
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
    async uploadSignatureTemp () {
      const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
      if (this.signatureFileTemp === null) {
        this.displayWarning = true
      } else this.displayWarning = false
      this.form.signature = await toBase64(this.signatureFileTemp)
      this.signatureLoaded = true
      // console.log(this.form.signature)
    },
    inactivateTeacherButton () {
      // si el estado anterior era activo, al presionar el btn se pasa
      // a inactivo y se muestra un warning y se deshabilitan los inputs
      // también cambia el texto del botón y el color.

      this.inactivateTeacher = !this.inactivateTeacher
      // inactivar docente
      this.showWarningInactive = this.inactivateTeacher
      this.disableFormInputs = this.inactivateTeacher
      this.inactiveTextButton.text = !this.inactivateTeacher ? 'Pasar Docente a Inactivo/a' : 'Pasar Docente a Activo/a'
      this.inactiveTextButton.color = this.inactivateTeacher ? 'success' : 'danger'
      this.warningMessage = this.showWarningInactive && 'Si desactiva a ' + this.form.name + ' ' + this.form.lastName + ' Los datos y clases asignadadas no van a eliminarse, sólo se asignará un color blanco para el calendario y seguirás viendo sus datos históricos'
    },
    removeTempSignature () {
      this.signatureFileTemp = null
      this.signatureLoaded = false
    },
    recoverSignature () {
      this.form.signature = this.teacherToEdit.x_signature
      this.signatureLoaded = true
    }
  }
}
</script>
